import React from "react"
import cx from "classnames"
import PropTypes from "prop-types"
import VisuallyHidden from "../visually-hidden"

const SIZES = {
  sm: "w-3 h-3",
  md: "w-5 h-5"
}

const STYLES = {
  sm: {
    padding: 2,
    width: 28
  },
  md: {
    padding: 2,
    width: 44
  }
}

const DISABLED_STYLES = {
  filter: "grayscale(100%)",
  cursor: "not-allowed",
  opacity: 0.75
}

const defaultBackground = {
  enabled: "bg-green-500",
  disabled: "bg-gray-500"
}

function Toggle({
  enabled,
  onClick,
  size = "md",
  background = {},
  readOnly,
  ...props
}) {
  const bg = { ...defaultBackground, ...background }
  const backgroundColor = enabled ? bg.enabled : bg.disabled
  const thumbPosition = enabled ? "translate-x-full" : "translate-x-0"
  const activeStyle = props.disabled
    ? { ...DISABLED_STYLES, ...STYLES[size] }
    : STYLES[size]
  const label = enabled ? "Disable" : "Enable"

  return (
    <button
      onClick={onClick}
      className={cx(
        backgroundColor,
        { "focus:shadow-outline": !readOnly },
        "inline-flex rounded-full transition-colors duration-200 focus:outline-none"
      )}
      style={activeStyle}
      aria-checked={enabled}
      role="switch"
      tabIndex={readOnly ? -1 : 0}
      {...props}
    >
      {/* Thumb */}
      <div
        className={`bg-white rounded-full transition-all duration-200 transform ${thumbPosition} ${SIZES[size]}`}
      />

      {/* A11y */}
      <VisuallyHidden>{label}</VisuallyHidden>
    </button>
  )
}

Toggle.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "md"]),
  background: PropTypes.shape({
    enabled: PropTypes.string,
    disabled: PropTypes.string
  }),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
}

export default Toggle
